export function group_line_items(line_items_object) {
	const line_items = Object.entries(line_items_object).map(([ key, item ], i) => ({ key, item, sort_order: i }))
	const group_ids = [ ...new Set(line_items.map(({ item }) => item.lineitem_group_id)) ].filter(Boolean)

	return [
		...line_items.filter(({ item }) => !item.lineitem_group_id).map(item => ({
			items: [ item ],
			sort_order: item.sort_order,
		})),
		...group_ids.map(group_id => {
			const items = line_items.filter(({ item }) => item.lineitem_group_id === group_id)
			return {
				group_id,
				items,
				quantity: Math.min(...items.map(({ item }) => Math.floor(item.quantity / (item.sales_kit_item_quantity || 1)))),
				sort_order: items[0].sort_order,
			}
		}),
	].sort((a, b) => a.sort_order - b.sort_order)
}
